const validationKeysEN = {
  translation: {
    "v-key-todo": "Todo",
  },
};

export default validationKeysEN;
